import * as React from 'react';
import { ISrcset } from './ISrcset';

export const Srcset = ({ image, className = '' }: { image: ISrcset; className?: string }) => {
  if (!image?.items || image.items.length === 0) {
    return null;
  }

  return (
    <picture>
      {image.items
        // empty media effectivly always matches
        .filter((image) => !!image.media)
        .map((item, sequence) => (
          <source key={sequence} media={item.media} srcSet={item.src} />
        ))}

      <img src={image.defaultSrc} alt={image.imageCaption} className={`img-fluid ${className}`} />
    </picture>
  );
};
